import FactoryComponents from '../../../../factory/components/FactoryComponents.js';
import { getRolePermissions, getHavePermission } from "@/api/companyManager.js"
const root = {}
export default root
root.name = 'roleManager';
root.data = {
	titleName: '',
	roleList: [],
	thisRoleAuthorize: {
		add: false,
		del: false,
		edit: false,
		look: false
	},
	thisEdit: {
		//仅仅用来在初始化的时候展开界面基本信息
		nameOpen: '1',
		//角色Id
		thisId: 0,
		//角色名称
		name: '',
		//角色说明
		remark: '',
		//角色对应当权限信息
		menuByRoles: [],
		//该值用来判断当前操作是新增还是编辑角色。和编辑权限一起控制保存按钮。当角色满足编辑或者新建当中任意一个权限时，显示保存按钮
		operaAdd: false,
		//操作权限的Id
		authorizeIds: [],
	},
	tableTitle: [{
			title: '功能',
			slot: 'features'
		},
		{
			title: '授权操作',
			slot: 'authorize'
		},
	],
	// 权限树数据
	PermissionList: [],
	defaultProps: {
		children: "childList",
		label: "menuName",
	},
	// 树形图选中的id， 包含全选和半选
	checkedIds: []
};
root.methods = {

	//获取角色数据
	getMenuByRole: function(id, name, remark) {
		if (id === 0) {
			this.thisEdit.operaAdd = true;
		} else {
			this.thisEdit.operaAdd = false;
		}
		this.thisEdit.authorizeIds = [];
		this.thisId = id;
		const that = this;
		const data = "?roleId=" + id;
		this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').menuByRole+data)
			.openLoad().startGet().then((res) => {
				that.thisEdit.menuByRoles = res.body.data;
				that.thisEdit.name = name;
				that.thisEdit.remark = remark;
				that.thisEdit.nameOpen = '1';
				// that.thisEdit.menuByRoles.forEach((item, index)=>{
				// 	that.initAuthorizeIds(item,);
				// })
			});
		getHavePermission({ roleId: id }).then(res => {
			let arr = res.body.data
			let chooseArr = []
			this.checkedIds = []
			for(let i in arr) {
				this.checkedIds.push(arr[i].id)
				// if(arr[i].haveChild === 0 && arr[i].spare === "1") {
				if(arr[i].spare === "1") {
					chooseArr.push(arr[i].id)
				}
			}
			this.$refs.tree.setCheckedKeys(chooseArr);
		})
	},

	// 获取权限数据
	getPermissionList() {
		getRolePermissions().then(res => {
			this.PermissionList = res.body.data
		})
	},

	// 选中树形控件选择框的事件
	nodeCheck(a, b, c, d) {
		// 这里用b， b可以拿到全选节点和半选节点的id
		this.checkedIds = b.checkedKeys.concat(b.halfCheckedKeys)
		console.log(this.checkedIds)
	},

	roleManagerSave: function() {
		if(this.thisEdit.name === '' || this.thisEdit.name === null || this.thisEdit.name === undefined){
			this.$message({
				message:'请输入名称',
				type: 'error'
			});
			return;
		}
		if (this.thisEdit.operaAdd) {
			this.roleManagerAdd();
		} else {
			this.roleManagerEdit();
		}
	},

	initAuthorizeIds: function(array){
		if(array.childMenu && array.childMenu.length > 0){
			array.childMenu.forEach((item, index)=>{
				this.initAuthorizeIds(item);
			});
		}else{
			if(array.hasAuth){
				this.thisEdit.authorizeIds.push(array.id);
			}
		}
	},

	chooseAuthorizeIds: function(ids) {
		const isAdd = ids.split("-")[0] === 'add';
		const id = parseInt(ids.split("-")[1]);
		if (isAdd) {
			const index = this.thisEdit.authorizeIds.indexOf(id);
			if (index < 0) {
				this.thisEdit.authorizeIds.push(id);
			}
		} else {
			const index = this.thisEdit.authorizeIds.indexOf(id);
			if (index > -1) {
				this.thisEdit.authorizeIds.splice(index, 1);
			}
		}

	},

	//新增角色
	roleManagerAdd: function() {
		let formdata = new FormData();
		formdata.append("roleName", this.thisEdit.name);
		formdata.append("remark", this.thisEdit.remark);
		// formdata.append("menuIds", JSON.stringify(this.thisEdit.authorizeIds));
		formdata.append("menuIds", JSON.stringify(this.checkedIds))
		const that = this;
		this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').addRole)
			.openLoad().startPost(formdata).then((res) => {
				that.getUserRole(res.body.data.id, res.body.data.roleName, res.body.data.remark);
				this.$message.success('新增成功')
			});
	},

	//刷新角色
	getUserRole: function(id, name, remark){
		const that = this;
		this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').roleGetUrl)
		.startGet().then((res)=>{
			that.componentsMoudel.setData('userDataRole', res.body.data);
			that.roleInforInit(id, name, remark);
			that.roleList = res.body.data;
		});
	},
//获取用户角色
	/*getUserRole: function() {
		const that = this;
		this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').roleGetUrl)
			.startGet().then((res) => {

		});
	},*/
	//编辑角色
	roleManagerEdit: function() {
		const that = this;
		let formdata = new FormData();
		formdata.append("roleName", this.thisEdit.name);
		formdata.append("roleId", this.thisId);
		formdata.append("remark", this.thisEdit.remark);
		// formdata.append("menuIds", JSON.stringify(this.thisEdit.authorizeIds));
		formdata.append("menuIds", JSON.stringify(this.checkedIds))
		this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').updateMenuByRole)
			.openLoad().startPut(formdata).then((res) => {
				that.getUserRole(that.thisId, that.thisEdit.name, that.thisEdit.remark);
				this.$message.success('编辑成功')
			});
	},

	//删除角色
	roleManagerDelRole: function(id) {
		const that = this;
		this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').deleteRole+'/'+id)
			.openLoad().startDel().then((res) => {
				that.getUserRole(0, '', '');
			});
	},



	//初始化数据
	roleInforInit: function(id, name, remark) {
		// let menuDatas = this.componentsMoudel.getData(this.$route.path);
		let menuDatas = JSON.parse(localStorage.getItem('navItem'));
		// this.titleName = menuDatas.menuName;
		this.getUserRole();
		const roleMenu = this.componentsMoudel.getData('/companyManager/roleManager');
		// if (roleMenu) {
		// 	roleMenu.childMenu.forEach((item, index) => {
		// 		if (item.menuName === '新建') {
		// 			if (item.hasAuth) {
		// 				this.getMenuByRole(id, name, remark);
		// 			}
		// 			this.thisRoleAuthorize.add = item.hasAuth;
		// 		}

		// 		if (item.menuName === '查看') {
		// 			this.thisRoleAuthorize.look = item.hasAuth;
		// 		}
		// 		if (item.menuName === '删除') {
		// 			this.thisRoleAuthorize.del = item.hasAuth;
		// 		}
		// 		if (item.menuName === '编辑') {
		// 			this.thisRoleAuthorize.edit = item.hasAuth;
		// 		}
		// 	});
		// }
	}
};
root.mounted = function() {
	this.roleInforInit(0, '', '');
	this.getPermissionList()
}

FactoryComponents.initComponent(root);
